// extracted by mini-css-extract-plugin
export default {"sidebarBackground":"Sidebar_sidebarBackground__ZcPCV","fadeIn":"Sidebar_fadeIn__-rXAA"};